import { createSlice } from '@reduxjs/toolkit';
import { getLocale } from '../../utils';

import { ApplicationState } from '../../types';

import { APPLICATION_STATE } from '../../constants';

import { setDirections } from './setDirectories';
import { setLocale } from './setLocale';
import { deleteNotice } from './deleteNotice';
import { setNotice } from './setNotice';
import { setSuccessNotice } from './setSuccessNotice';
import { setErrorNotice } from './setErrorNotice';
import { setShowOrderCardsModal } from './setShowOrderCardsModal';
import { setActiveModals } from './setActiveModals';
import { addActiveModal } from './addActiveModal';
import { deleteActiveModal } from './deleteActiveModal';
import { setFeatureFlags } from './setFeatureFlags';
import { setFeatureFlagsLoadingStatus } from './setFeatureFlagsLoadingStatus';

const initialState: ApplicationState = {
  i18n: {
    locale: getLocale()
  },
  isLoading: '',
  showOrderCardsModal: false,
  countries: [],
  roadsideService: [],
  stationCategories: [],
  serviceFormats: [],
  additionalParams: [],
  additionalServices: [],
  services: [],
  notice: null,
  activeModals: [],
  featureFlags: {}
};

export const applicationSlice = createSlice({
  name: APPLICATION_STATE,
  initialState,
  reducers: {
    setDirections,
    setLocale,
    deleteNotice,
    setNotice,
    setSuccessNotice,
    setErrorNotice,
    setShowOrderCardsModal,
    setActiveModals,
    addActiveModal,
    deleteActiveModal,
    setFeatureFlags,
    setFeatureFlagsLoadingStatus
  }
});

export const applicationActions = applicationSlice.actions;
export const applicationReducer = applicationSlice.reducer;
